import React from 'react';
import createReactClass from 'create-react-class';
import axios from 'axios';
import {Button, Card} from 'uiKit';
import Validator from 'validator';
import _ from 'lodash';
import LP from 'modules/app/helpers/lp';
import ReactGA from 'react-ga';
import AlertInfo from 'modules/app/components/alertInfo';

var Register = createReactClass({

    componentDidMount: function() {
        this._passwordInput.focus();

        if (window.generalSettings._shouldUseGoogleAnalytics && window.generalSettings._googleAnalyticsTrackingId) {
            ReactGA.initialize(window.generalSettings._googleAnalyticsTrackingId);
            ReactGA.set({ page: location.pathname });
            ReactGA.pageview(location.pathname);
        }
    },

    getInitialState: function() {
        return {
            password: {
                'value': '',
                'error': ''
            },
            passwordCheck: {
                'value': '',
                'error': ''
            }
        }
    },

    validateForm: function(field) {

        switch(field) {
            case 'password':
                if (this.state.password.value.length <= 7) {
                    this.setError(field, LP('login', 'passwordLengthError', 'sentencecase'));
                } else {
                    this.setError(field, '');
                }
                break;
            case 'passwordCheck':
                if (this.state.password.value != this.state.passwordCheck.value) {
                    this.setError(field, LP('login', 'passwordMatchError', 'sentencecase'));
                } else {
                    this.setError(field, '');
                }
                break;
        }


    },

    setError: function(field, error) {
        var newAttribute = _.extend(this.state[field], {
            error: error
        });

        var newState = {};

        newState[field] = newAttribute;

        this.setState(newState);

    },

    setValue: function(field, value) {
        var newAttribute = _.extend(this.state[field], {
            value: value
        });

        var newState = {};

        newState[field] = newAttribute;

        this.setState(newState);
    },

    isValid: function() {
        var isValid = true;

        _.each(this.state, function(value) {
            if (value.error) {
                isValid = false;
            }
        });

        return isValid;

    },

    onRegisterClicked: function(event) {
        event.preventDefault();

        if (this.isValid()) {

            var splitWindowLocation = window.location.href.split('/');
            var userId = splitWindowLocation[splitWindowLocation.length-1];
            
            axios.post('../register/' + userId, {
                password: this.state.password.value
            }).then(() => {
                this.setState({
                    isPasswordSet: true 
                });
            }).catch((error) => {
                this.setState({
                    error: error.response.data.message,
                    isPasswordExpiredError: error.response.data._isPasswordExpiredError
                });
            });

        }
    },

    onPasswordChanged: function(event) {
        this.setValue('password', event.target.value);
        this.validateForm('password');
        this.validateForm('passwordCheck');
    },

    onPasswordCheckChanged: function(event) {
        this.setValue('passwordCheck', event.target.value);
        this.validateForm('password');
        this.validateForm('passwordCheck');
    },

    resendRegistrationLink: function() {
        var splitWindowLocation = window.location.href.split('/');
        var passwordToken = splitWindowLocation[splitWindowLocation.length-1];
        
        axios.post('../api/resendRegistrationEmailByPasswordToken/' + passwordToken).then(() => {
            this.setState({
                _hasRegistrationEmailResent: true
            });
        }).catch((error) => {
            this.setState({
                error: error.response.data.message,
            });
        });
    },

    renderBody: function() {
        if (LP('users', 'registerPasswordBody')) {
            return (
                <div className="register-body">
                    {LP('users', 'registerPasswordBody', 'sentencecase')}
                </div>
            )
        }
    },

    renderError: function() {
        if (this.state.error) {
            const error = this.state.isPasswordExpiredError ? `<a>${this.state.error}</a>` : this.state.error;
            const onClick = this.state.isPasswordExpiredError ? this.resendRegistrationLink : null;

            return (
                <AlertInfo
                    className="register-error"
                    text={error}
                    type="warning"
                    icon="alert"
                    onClick={onClick}
                />
            );
        }
    },

    renderLogo: function() {
        var logo = window.generalSettings._logo;
        var shouldShowLogoOnLogin = window.generalSettings._shouldShowLogoOnLogin;
        
        if (logo && shouldShowLogoOnLogin) {
            logo = '/' + logo.replace('/images/', '/logo/');

            return (
                <div className="register-logo" style={{height: window.generalSettings._navigationHeight + 'px'}}>
                    <div className="register-logo-inner">
                        <a href='/'>
                            <img
                                className="register-logo-graphic"
                                src={logo}
                                style={{height: (window.generalSettings._navigationHeight - 18) + 'px'}}
                            />
                        </a>
                    </div>
                </div>
            );
        }
    },

    render: function() {
        var logo = window.generalSettings._logo;
        var shouldShowLogoOnLogin = window.generalSettings._shouldShowLogoOnLogin;
        var styles = {};        

        if (logo && shouldShowLogoOnLogin) {
            styles = {"paddingTop": window.generalSettings._navigationHeight + 'px'}; 
        } else {
            styles = null;
        }

        if (this.state.isPasswordSet) {
            const successText = 'You’ve successfully set your password. Navigate <a href="/login">here</a> to login.'

            return (
                <div className="register-container">
                    <Card className="register">
                        {this.renderLogo()}
                        <h1 className="register-title" style={styles}>
                            {LP('users', 'register', 'sentencecase')}
                        </h1>                        
                        <AlertInfo
                            text={successText}
                            type="success"
                            icon="checkmark-circle"
                        />
                    </Card>
                </div>
            );
        }

        if (this.state._hasRegistrationEmailResent) {
            return (
                <div className="register-container">
                    <Card className="register">
                        {this.renderLogo()}
                        <h1 className="register-title" style={styles}>
                            {LP('users', 'register', 'sentencecase')}
                        </h1>                        
                        <AlertInfo
                            text={LP('login', 'registrationEmailResendSuccess', 'sentencecase')}
                            type="success"
                            icon="mailbox-full"
                        />
                    </Card>
                </div>
            );
        }

        return (
            <div className="register-container">
                <Card className="register">
                    {this.renderLogo()}
                    <h1 className="register-title" style={styles}>
                        {LP('users', 'register', 'sentencecase')}
                    </h1>
                    {this.renderBody()}
                    <form>
                        <div className="form-field">
                            <label className="form-field-label" htmlFor="register-password">{LP('users', 'password', 'titlecase')}</label>
                            <input id="register-password" aria-required onChange={this.onPasswordChanged} value={this.state.password.value} type="password" ref={(c) => this._passwordInput = c}/>
                            <div className="form-field-error">
                                {this.state.password.error}
                            </div>
                        </div>
                        <div className="form-field">
                            <label className="form-field-label" htmlFor="register-password-check">{LP('users', 'passwordCheck', 'titlecase')}</label>
                            <input id="register-password-check" aria-required onChange={this.onPasswordCheckChanged} value={this.state.passwordCheck.value} type="password"/>
                            <div className="form-field-error">
                                {this.state.passwordCheck.error}
                            </div>
                        </div>
                        {this.renderError()}
                        <Button className="button primary large full-width" onClick={this.onRegisterClicked} text={LP('users', 'registerPasswordActionButton', 'sentencecase')}/>
                    </form>
                </Card>
            </div>
        );
    }

});

export default Register;